export default __webpack_public_path__ + "static/media/basketblue.4e8e496c.svg";